if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        // Prioritize cart-drawer over cart-notification
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

            const selectedSize = document.querySelector(
  '.size-picker input[type="radio"]:checked:not(.toggle-radio)'
);
        const selectedLength = document.querySelector(
          '.length-picker input[type="radio"]:checked'
        );
        const sellength = document.querySelector(
          '.length-picker input[type="radio"]'
        );
        const sizeErrorEl = document.querySelector(
          ".product-form__error-message-wrapper-variant"
        );

        if (!selectedSize) {
          if (sizeErrorEl) {
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Size";
          }
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
          return;
        }
        if (!selectedLength && sellength != null) {
    
          if (sizeErrorEl) {
            sizeErrorEl.style.display = "block";
            const span = sizeErrorEl.querySelector("span");
            if (span) span.textContent = "Select Length";
          }
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
          return;
        }
        
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const baseFormData = new FormData(this.form);
        const quantity = parseInt(baseFormData.get("quantity") || 1);

        const sections =
          typeof this.cart?.getSectionsToRender === "function"
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : ["cart-drawer", "cart-icon-bubble"];

        const getLocalePrefix = () => {
          const path = window.location.pathname;
          const match = path.match(/^\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)/);
          return match ? "/" + match[1] : "";
        };

        const addSingleItem = async () => {
          const formData = new FormData();
          for (let [key, value] of baseFormData.entries()) {
            if (key !== "quantity") formData.append(key, value);
          }

          formData.append("quantity", 1);
          formData.append("sections", sections.join(","));
          formData.append("sections_url", window.location.pathname);
          formData.append("properties[_unique_id]", crypto.randomUUID());

          const res = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (!res.ok) {
            const errorData = await res.json();
            throw new Error(errorData?.description || "Add to cart failed");
          }

          await updateCustomerCartMetafield();
          return res.json();
        };

        const renderCartContents = async () => {
          const cartData = await fetch("/cart.js").then((res) => res.json());
          sessionStorage.setItem('cart_trial', JSON.stringify(cartData));
          //await updateCustomerCartMetafield();
          // Mobile/Tablet behavior (≤1024px)
          // if (window.innerWidth <= 1024) {
          //   const notification = document.getElementById(
          //     "AddedToBagNotification"
          //   );
          //   if (notification) {
          //     notification.classList.remove("hidden");

          //     setTimeout(() => {
          //       notification.classList.add("hidden");
          //     }, 3000);
          //   }

          //   // Still update cart bubble
          //   try {
          //     const sectionsData = await fetch(
          //         `${getLocalePrefix()}/?sections=cart-icon-bubble`
          //     ).then((res) => res.json());

          //     const bubble = document.querySelector("#cart-icon-bubble");
          //     if (bubble && sectionsData["cart-icon-bubble"]) {
          //       const parsedBubble = new DOMParser()
          //         .parseFromString(
          //           sectionsData["cart-icon-bubble"],
          //           "text/html"
          //         )
          //         .querySelector(".shopify-section");
          //       if (parsedBubble) {
          //         bubble.innerHTML = parsedBubble.innerHTML;
          //       }
          //     }
          //   } catch (e) {
          //     console.error("Error updating cart bubble:", e);
          //   }

          //   return; // stop here (don’t open cart-drawer)
          // }

            if (window.innerWidth <= 1024) {
            const notification = document.getElementById(
              "AddedToBagNotification"
            );

            // Detect ?app-view=true
            const urlParams = new URLSearchParams(window.location.search);
            const isAppView = urlParams.get("app-view") === "true";

            if (isAppView) {
              // Remove existing modal if any
              if (notification) notification.classList.add("hidden");

              // Create the app-view style flyout
              const existingFlyout = document.querySelector(
                ".app-view-add-to-bag-flyout"
              );
              if (existingFlyout) existingFlyout.remove();

              const flyout = document.createElement("div");
              flyout.className = "app-view-add-to-bag-flyout";
              flyout.innerHTML = `
      <div class="flyout-text">Item Added</div>
      <a href="/cart?app-view=true" class="flyout-btn">VIEW BAG </a>
    `;
              document.body.appendChild(flyout);

              // Auto-hide after 3s
              setTimeout(() => {
                flyout.remove();
              }, 3000);
            } else {
              // Default existing modal behavior
              if (notification) {
                notification.classList.remove("hidden");
                setTimeout(() => {
                  notification.classList.add("hidden");
                }, 3000);
              }
            }

            // Still update cart bubble as before
            try {
              const sectionsData = await fetch(
                `${getLocalePrefix()}/?sections=cart-icon-bubble`
              ).then((res) => res.json());
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                const parsedBubble = new DOMParser()
                  .parseFromString(
                    sectionsData["cart-icon-bubble"],
                    "text/html"
                  )
                  .querySelector(".shopify-section");
                if (parsedBubble) {
                  bubble.innerHTML = parsedBubble.innerHTML;
                }
              }
            } catch (e) {
              console.error("Error updating cart bubble:", e);
            }

            return; // stop here (don’t open cart-drawer)
          }

          // Desktop behavior (>1024px) → cart-drawer as usual
          const sectionsData = await fetch(
            `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`
          ).then((res) => res.json());

          if (this.cart && typeof this.cart.renderContents === "function") {
            try {
              this.cart.renderContents({
                items: cartData.items,
                sections: sectionsData,
                total_price: cartData.total_price,
              });
            } catch (e) {
              console.error("Error rendering cart contents:", e);
            }
          }

          if (
            this.cart &&
            this.cart.tagName.toLowerCase() === "cart-drawer" &&
            typeof this.cart.open === "function"
          ) {
            try {
              this.cart.open(this.submitButton);
              this.cart.classList.add("animate", "active");
              this.cart.style.display = "block";
              this.cart.style.visibility = "visible";
            } catch (e) {
              console.error("Error opening cart drawer:", e);
              window.location.href = "/cart";
            }
          } else {
            // fallback
            try {
              const bubble = document.querySelector("#cart-icon-bubble");
              if (bubble && sectionsData["cart-icon-bubble"]) {
                bubble.dispatchEvent(new Event("click", { bubbles: true }));
              } else {
                window.location.href = "/cart";
              }
            } catch (e) {
              console.error("Error triggering cart bubble:", e);
              window.location.href = "/cart";
            }
          }
        };

        (async () => {
          try {
            let sectionsData = {};
            for (let i = 0; i < quantity; i++) {
              const response = await addSingleItem();
              if (response.sections) {
                sectionsData = { ...sectionsData, ...response.sections };
              }
            }

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      renderCartContents
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                "add:paint-updated-sections",
                renderCartContents
              );
            }
          } catch (error) {
            this.handleErrorMessage(error.message || "Failed to add item.");
            document.body.classList.remove("overflow-hidden");
          } finally {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            CartPerformance.measureFromEvent("add:user-action", evt);
          }
        })();
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute("aria-disabled", true);
      //   this.submitButton.classList.add("loading");
      //   this.querySelector(".loading__spinner").classList.remove("hidden");

      //   const config = fetchConfig("javascript");
      //   config.headers["X-Requested-With"] = "XMLHttpRequest";
      //   delete config.headers["Content-Type"];

      //   // const formData = new FormData(this.form);
      //   const baseFormData = new FormData(this.form);
      //   const quantity = parseInt(baseFormData.get("quantity") || 1);

      //   const sections =
      //     typeof this.cart?.getSectionsToRender === "function"
      //       ? this.cart.getSectionsToRender().map((section) => section.id)
      //       : ["cart-drawer", "cart-icon-bubble"];

      //   const addSingleItem = async () => {
      //     const formData = new FormData();
      //     for (let [key, value] of baseFormData.entries()) {
      //       if (key !== "quantity") formData.append(key, value);
      //     }

      //     formData.append("quantity", 1);
      //     formData.append("sections", sections);
      //     formData.append("sections_url", window.location.pathname);
      //     formData.append("properties[_unique_id]", crypto.randomUUID());

      //     const res = await fetch("/cart/add.js", {
      //       method: "POST",
      //       body: formData,
      //       headers: {
      //         "X-Requested-With": "XMLHttpRequest",
      //       },
      //     });

      //     if (!res.ok) {
      //       const errorData = await res.json();
      //       throw new Error(errorData?.description || "Add to cart failed");
      //     }

      //     return res.json();
      //   };

      //   const quickAddModal = this.closest("quick-add-modal");

      //   const renderCartContents = async () => {
      //     const cartData = await fetch("/cart.js").then((res) => res.json());

      //     if (this.cart && typeof this.cart.renderContents === "function") {
      //       try {
      //         this.cart.renderContents(cartData);
      //       } catch (e) {}
      //     } else {
      //       window.location.href = "/cart";
      //     }
      //   };

      //   (async () => {
      //     try {
      //       for (let i = 0; i < quantity; i++) {
      //         await addSingleItem();
      //       }
      //       window.location.reload();

      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           "modalClosed",
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure(
      //                 "add:paint-updated-sections",
      //                 renderCartContents
      //               );
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure(
      //           "add:paint-updated-sections",
      //           renderCartContents
      //         );
      //       }
      //     } catch (error) {
      //       this.handleErrorMessage(error.message || "Failed to add item.");
      //       document.body.classList.remove("overflow-hidden");
      //     } finally {
      //       this.submitButton.classList.remove("loading");
      //       if (this.cart && this.cart.classList.contains("is-empty")) {
      //         this.cart.classList.remove("is-empty");
      //       }
      //       this.submitButton.removeAttribute("aria-disabled");
      //       this.querySelector(".loading__spinner").classList.add("hidden");

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     }
      //   })();
      //   if (this.cart) {
      //     // Fallback to default sections if getSectionsToRender is not available
      //     const sections =
      //       typeof this.cart.getSectionsToRender === "function"
      //         ? this.cart.getSectionsToRender().map((section) => section.id)
      //         : ["cart-drawer", "cart-icon-bubble"];
      //     formData.append("sections", sections);
      //     formData.append("sections_url", window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: "product-form",
      //           productVariantId: formData.get("id"),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage =
      //           this.submitButton.querySelector(".sold-out-message");
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute("aria-disabled", true);
      //         this.submitButtonText.classList.add("hidden");
      //         soldOutMessage.classList.remove("hidden");
      //         this.error = true;
      //         return;
      //       }

      //       const startMarker = CartPerformance.createStartingMarker(
      //         "add:wait-for-subscribers"
      //       );
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: "product-form",
      //           productVariantId: formData.get("id"),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker(
      //             "add:wait-for-subscribers",
      //             startMarker
      //           );
      //         });
      //       this.error = false;

      //       const quickAddModal = this.closest("quick-add-modal");
      //       const renderCartContents = () => {
      //         // Open cart drawer first
      //         if (
      //           this.cart &&
      //           this.cart.tagName.toLowerCase() === "cart-drawer" &&
      //           typeof this.cart.open === "function"
      //         ) {
      //           try {
      //             this.cart.open(this.submitButton);
      //             // Ensure visibility
      //             this.cart.classList.add("animate", "active");
      //             this.cart.style.display = "block";
      //             this.cart.style.visibility = "visible";
      //             const cartDrawerInner =
      //               this.cart.querySelector("#CartDrawer");
      //             if (cartDrawerInner) {
      //               cartDrawerInner.style.transform = "translateX(0)";
      //               cartDrawerInner.style.right = "0";
      //             }
      //             const cartInnerContent = this.cart.querySelector(
      //               ".cart-drawer__inner"
      //             );
      //             if (cartInnerContent) {
      //               cartInnerContent.style.display = "flex";
      //               cartInnerContent.style.visibility = "visible";
      //               cartInnerContent.style.position = "relative";
      //               cartInnerContent.style.right = "0";
      //             }
      //             const overlay = this.cart.querySelector(
      //               "#CartDrawer-Overlay"
      //             );
      //             if (overlay) {
      //               overlay.classList.add("active");
      //               overlay.style.display = "block";
      //               overlay.style.opacity = "1";
      //               overlay.style.zIndex = "49";
      //             } else {
      //               document.body.classList.remove("overflow-hidden");
      //             }
      //           } catch (e) {
      //             document.body.classList.remove("overflow-hidden");
      //             const cartIcon = document.querySelector("#cart-icon-bubble");
      //             if (cartIcon) {
      //               cartIcon.dispatchEvent(
      //                 new Event("click", { bubbles: true })
      //               );
      //             } else {
      //               document.body.classList.remove("overflow-hidden");
      //             }
      //           }
      //         } else {
      //           document.body.classList.remove("overflow-hidden");
      //           const cartIcon = document.querySelector("#cart-icon-bubble");
      //           if (cartIcon) {
      //             cartIcon.dispatchEvent(new Event("click", { bubbles: true }));
      //           }
      //         }
      //         // Update cart contents
      //         if (
      //           this.cart &&
      //           typeof this.cart.renderContents === "function" &&
      //           response.items
      //         ) {
      //           try {
      //             this.cart.renderContents(response);
      //           } catch (e) {}
      //         }
      //         // Fallback: Try rendering via cart-items
      //         if (
      //           this.cart &&
      //           this.cart.tagName.toLowerCase() === "cart-drawer"
      //         ) {
      //           const cartItems = this.cart.querySelector("cart-items");
      //           if (
      //             cartItems &&
      //             typeof cartItems.renderContents === "function" &&
      //             response.items
      //           ) {
      //             try {
      //               cartItems.renderContents(response);
      //             } catch (e) {}
      //           }
      //           // Fallback: Manually update cart-drawer HTML
      //           if (response.sections && response.sections["cart-drawer"]) {
      //             try {
      //               const drawerInner =
      //                 this.cart.querySelector(".drawer__inner") || this.cart;
      //               if (drawerInner) {
      //                 drawerInner.innerHTML = response.sections["cart-drawer"];
      //                 if (
      //                   drawerInner.classList.contains("cart-drawer__inner")
      //                 ) {
      //                   drawerInner.style.display = "flex";
      //                   drawerInner.style.visibility = "visible";
      //                   drawerInner.style.position = "relative";
      //                   drawerInner.style.right = "0";
      //                   drawerInner.style.opacity = "1";
      //                 }
      //               } else {
      //                 document.body.classList.remove("overflow-hidden");
      //               }
      //             } catch (e) {
      //               document.body.classList.remove("overflow-hidden");
      //             }
      //           } else {
      //             document.body.classList.remove("overflow-hidden");
      //           }
      //         }
      //         // Update cart-icon-bubble
      //         if (response.sections && response.sections["cart-icon-bubble"]) {
      //           try {
      //             const bubble = document.querySelector("#cart-icon-bubble");
      //             if (bubble) {
      //               bubble.innerHTML = response.sections["cart-icon-bubble"];
      //             }
      //           } catch (e) {}
      //         }
      //         // Check visibility after update
      //         setTimeout(() => {
      //           const cartInnerContent = this.cart.querySelector(
      //             ".cart-drawer__inner"
      //           );
      //           const cartDrawerInner = this.cart.querySelector("#CartDrawer");
      //           const isVisible =
      //             this.cart.classList.contains("active") &&
      //             window.getComputedStyle(this.cart).visibility === "visible" &&
      //             cartInnerContent &&
      //             window.getComputedStyle(cartInnerContent).display ===
      //               "flex" &&
      //             window.getComputedStyle(cartInnerContent).visibility ===
      //               "visible" &&
      //             cartDrawerInner &&
      //             cartDrawerInner.getBoundingClientRect().right > 0 &&
      //             cartDrawerInner.getBoundingClientRect().right <=
      //               window.innerWidth;
      //           if (!isVisible) {
      //             const cartIcon = document.querySelector("#cart-icon-bubble");
      //             if (cartIcon) {
      //               cartIcon.dispatchEvent(
      //                 new Event("click", { bubbles: true })
      //               );
      //             } else {
      //               document.body.classList.remove("overflow-hidden");
      //               const overlay = this.cart.querySelector(
      //                 "#CartDrawer-Overlay"
      //               );
      //               if (overlay) {
      //                 overlay.classList.remove("active");
      //                 overlay.style.display = "none";
      //               }
      //             }
      //           }
      //         }, 500);
      //       };

      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           "modalClosed",
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure(
      //                 "add:paint-updated-sections",
      //                 renderCartContents
      //               );
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure(
      //           "add:paint-updated-sections",
      //           renderCartContents
      //         );
      //       }
      //     })
      //     .catch((e) => {
      //       document.body.classList.remove("overflow-hidden");
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove("loading");
      //       if (this.cart && this.cart.classList.contains("is-empty"))
      //         this.cart.classList.remove("is-empty");
      //       if (!this.error) this.submitButton.removeAttribute("aria-disabled");
      //       this.querySelector(".loading__spinner").classList.add("hidden");

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
